module.exports = __webpack_public_path__ + "static/media/headergruen.25bf07d4.jpg";